import PubSub from 'pubsub-js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

const section = {
  init() {
    this.$sections = document.querySelectorAll('section.section_module');
    this.$fixedBg = document.getElementById('fixed_bg');
    this.$quickNav = document.getElementById('quick_nav');

    if (this.$sections !== null && this.$sections.length) {
      console.log('Section init!');

      this.destroyBinded = this.destroy.bind(this);
      this.resizeHandlerBinded = this.resizeHandler.bind(this);
      this.processSections();
      this.setUpListeners();
    }
  },

  /* eslint-disable */
  // accelerating from zero velocity
  easeInQuad: t => t*t,
  // decelerating to zero velocity
  easeOutQuad: t => t*(2-t),
  // acceleration until halfway, then deceleration
  easeInOutQuad: t => t<.5 ? 2*t*t : -1+(4-2*t)*t,
  // accelerating from zero velocity
  easeInCubic: t => t*t*t,
  // decelerating to zero velocity
  easeOutCubic: t => (--t)*t*t+1,
  // acceleration until halfway, then deceleration
  easeInOutCubic: t => t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1,
  // accelerating from zero velocity
  easeInQuart: t => t*t*t*t,
  // decelerating to zero velocity
  easeOutQuart: t => 1-(--t)*t*t*t,
  // acceleration until halfway, then deceleration
  easeInOutQuart: t => t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t,
  // accelerating from zero velocity
  easeInQuint: t => t*t*t*t*t,
  // decelerating to zero velocity
  easeOutQuint: t => 1+(--t)*t*t*t*t,
  // acceleration until halfway, then deceleration
  easeInOutQuint: t => t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t,
  /* eslint-enable */

  processSections() {
    const totalSections = this.$sections.length;

    this.$sections
      .forEach(($section, id) => {
        if (totalSections > 1) {
          this.buildQuickNav($section, id);
        }

        this.setSectionHeight($section);
        this.prepareForBgSwitch($section);
        this.setUpBgSwitch($section);
        this.setUpParallax($section);
      });

    this.$fixedBg.style.height = (window.innerHeight * 1.2) + 'px';
  },

  setSectionHeight($section) {
    $section.style.height = window.innerHeight + 'px';
  },

  setUpParallax($section) {
    ScrollTrigger.create({
      id: 'parallax',
      trigger: $section,
      scrub: true,
      // markers: true,
      onUpdate: ({progress, trigger}) => {
        // convert 0-1 progress into 0-1-0
        const opacityProgress = Math.abs(Math.abs((progress - 0.5) * 2) - 1);
        // convert 0-1 progress into 1-0-(-1)
        const bgProgress = (progress - 0.5) * -2;
        const row = trigger.dataset.row;
        const $bg = this.$fixedBg.querySelector(
          '.bg_wrapper[data-row="' + row + '"]'
        );
        const bgPos = window.innerWidth > 767
          ? (bgProgress * 5) + 'vw'
          : (bgProgress * 10) + 'vw';

        if ($bg !== null) {
          gsap.set($bg, {
            y: bgPos
          });
        }

        gsap.set(trigger.querySelector('.content'), {
          opacity: this.easeInOutQuad(opacityProgress)
        });
      }
    });
  },

  buildQuickNav($section, id) {
    const $item = document.createElement('BUTTON');
    const $bullet = document.createElement('DIV');
    const $label = document.createElement('DIV');

    $label.textContent = $section.dataset.title;

    $item.dataset.sid = $section.getAttribute('id');
    $item.append($bullet, $label);
    $item.addEventListener('click', this.handleNavClick);

    if (id === 0) {
      $item.classList.add('active');
    }

    this.$quickNav.appendChild($item);
  },

  handleNavClick(ev) {
    const $btn = ev.currentTarget;

    $btn
      .closest('#quick_nav')
      .querySelector('.active')
      .classList.remove('active');

    $btn.classList.add('active');

    // only scroll to section if the event is real
    if (ev.target) {
      gsap.to(window, {
        scrollTo: {
          y: '#' + $btn.dataset.sid
        }
      });
    }
  },

  prepareForBgSwitch($section) {
    const $bg = $section.querySelector('.bg_wrapper').cloneNode(true);

    if (!$bg.classList.contains('solid')) {
      this.$fixedBg.appendChild($bg);
      gsap.set($bg, {
        opacity: 0
      });

      setTimeout(() => {
        this.coverVideo($bg);
      }, 10);
    }
  },

  coverVideo($bg) {
    if ($bg.classList.contains('iframe')
    || $bg.classList.contains('video')) {
      const $media = $bg.querySelector('video,iframe');
      const bgHeight = $bg.offsetHeight;

      if ((window.innerWidth / bgHeight) > 1.77777777) {
        $media.style.width = '';
        $media.style.height = (window.innerWidth  * 0.5625) + 'px';
      } else {
        // portrait
        $media.style.width = (bgHeight * 1.777777) + 'px';
        $media.style.height = '';
      }
    }
  },

  setUpBgSwitch($section) {
    ScrollTrigger.create({
      id: 'bg_switch',
      trigger: $section,
      // scroller: window.innerWidth > 767 ? '#app' : window,
      // scrub: true,
      // markers: true,
      // toggleActions: 'restart none restart none',
      start: '0% 70%',
      end: '100% 30%',
      onToggle: ({isActive, trigger, progress}) => {
        const row = trigger.dataset.row;
        const $bg = this.$fixedBg.querySelector(
          '.bg_wrapper[data-row="' + row + '"]'
        );

        if (isActive && this.$sections.length > 1) {
          this.handleNavClick({
            currentTarget: this.$quickNav.querySelector(
              '[data-sid="'+trigger.getAttribute('id')+'"]'
            )
          });
        }

        if (isActive && $bg !== null) {
          gsap.to($bg, {opacity: 1});
        } else if (!isActive && $bg !== null) {
          gsap.to($bg, {opacity: 0});
        }
      }
    });
  },

  toggleQuickNavColor(bgColor) {
    if (bgColor === 'FFFFFF' && !this.$quickNav.classList.contains('dark')) {
      this.$quickNav.classList.add('dark');
    } else if (bgColor !== 'FFFFFF'
      && this.$quickNav.classList.contains('dark')) {
      this.$quickNav.classList.remove('dark');
    }
  },

  setUpListeners() {
    PubSub.subscribe('page.transitionMiddle', this.destroyBinded);

    ScrollTrigger.create({
      id: 'nav_color_change',
      start: 0,
      end: 'max',
      onUpdate: () => {
        let navOverWhite = false;
        let quickNavOverWhite = false;

        this.$sections
          .forEach(($section, id) => {
            const $prevSection = $section.previousElementSibling;

            if ($section.dataset.bg === 'FFFFFF') {
              const pos = ScrollTrigger.positionInViewport($section, 'top');

              if (pos < 0.12 && pos > -0.3) {
                navOverWhite = true;
              }

              if (pos < 0.7 && pos > -0.3) {
                quickNavOverWhite = true;
              }
            }

            if ($prevSection !== null
            && $prevSection.dataset.bg === 'FFFFFF'
            && $section.dataset.bg === 'FFFFFF') {
              const pos = ScrollTrigger.positionInViewport($section, 'top');

              if (pos > 0.11 && pos < 0.71) {
                navOverWhite = true;
              }
            }
          });

        if (navOverWhite) {
          PubSub.publish('header.toggleColor', 'FFFFFF');
        } else {
          PubSub.publish('header.toggleColor', '000000');
        }

        if (quickNavOverWhite) {
          this.toggleQuickNavColor('FFFFFF');
        } else {
          this.toggleQuickNavColor('000000');
        }
      }
    });

    window.addEventListener('resize', this.resizeHandlerBinded);
  },

  prevWidth: Math.round(window.innerWidth),
  resizeHandler() {
    const newWidth = Math.round(window.innerWidth);

    if (newWidth !== this.prevWidth) {
      this.prevWidth = newWidth;
      console.log('Handling resize event');

      this.$sections
        .forEach(($section, id) => {
          const row = $section.dataset.row;
          const $bg = this.$fixedBg.querySelector(
            '.bg_wrapper[data-row="' + row + '"]'
          );

          this.setSectionHeight($section);

          if ($bg !== null) {
            this.coverVideo($bg);
          }
        });
    }
  },

  destroyTrigers() {
    const triggers = ScrollTrigger.getAll();

    triggers.forEach(trigger => {
      if (trigger.vars.id === 'parallax'
      || trigger.vars.id === 'bg_switch'
      || trigger.vars.id === 'nav_color_change') {
        trigger.kill();
        console.log('Destroying section ScrollTrigger triggers');
      }
    });

    ScrollTrigger.refresh();
  },

  destroyBgs() {
    //remove all bg clones without invoking html parser
    this.$fixedBg.textContent = '';
  },

  destroyQuickNav() {
    if (this.$quickNav.hasChildNodes()) {
      this.$quickNav
        .querySelectorAll('button')
        .forEach($btn => {
          $btn.removeEventListener('click', this.handleNavClick);
        });

      //remove all nav items without invoking html parser
      this.$quickNav.textContent = '';
    }
  },

  destroy() {
    console.log('Destroy: section module');

    this.destroyTrigers();
    this.destroyBgs();
    this.destroyQuickNav();

    PubSub.unsubscribe('page.transitionMiddle', this.destroyBinded);
    window.removeEventListener('resize', this.resizeHandlerBinded);
  }
};

PubSub.subscribe('page.inDOM', section.init.bind(section));

export default section;
